<template>
  <v-dialog v-model="orderDetailsModal" scrollable full-width max-width='933'>
    <v-card class="pl-5 pr-5 no-details" v-if="order.id !== undefined">
        <v-card-title class="pa-0 pt-4 pb-3">
          <v-flex>
            <span class="mt-2 mb-2 headline">Pedido ref.: </span><span class="titulo-detalhes mt-2 mb-2 headline"> {{ order.identifier}} </span>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex class="text-xs-right ">
            <v-btn class="ma-0" icon @click.native="orderDetailsModal = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <hr>
          </v-flex>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-form ref="scheduleForm">
            <v-layout row wrap class="pt-3 mb-3">
              <v-flex class="titulo-detalhes">
                Itens do pedido
              </v-flex>
                <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                {{ order.date | orderDateFilter }}
              </v-flex>
            </v-layout>
            <template lang="html" v-for="(item, index) in order.itens">
              <v-layout row :class="{'pt-1 pb-1' : true, 'divider-item' : index !== order.itens.length - 1}" :key="index">
                <v-flex class="order-color">
                  <strong>Qtde: {{ item.count }}</strong><br>
                </v-flex>
                <v-flex class="order-color">
                  <strong> {{ item.name }}</strong><br>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex class="order-color text-xs-right">
                  <strong> Valor Unit: {{ item.price | currency }}</strong><br>
                </v-flex>
                <v-flex class="order-color text-xs-right">
                  <strong>{{ ( item.price*item.count ) | currency }}</strong><br>
                </v-flex>
              </v-layout>
            </template>
            <v-layout row class="pt-3 mb-3">
              <v-flex class="order-color">
                <v-flex class="text-xs-right">Valor total: {{ totalPrice | currency }}</v-flex>
              </v-flex>
            </v-layout>
            <v-layout row class="payment-method mb-3" v-if="order.payment !== ''">
              <v-flex class="text-xs-center">
                Método de pagamento: {{ order.payment }}
              </v-flex>
            </v-layout>
            <v-layout row class="mb-3" v-else>
              <v-flex class="order-color">
                <hr class="divider-red">
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="titulo-detalhes">
                Endereço
              </v-flex>
              <v-flex xs10 class="order-color">
                {{ order.condominium.name }}<br>
                {{ order.condominium.address }}, {{ order.condominium.city }} - {{ order.condominium.state }}, {{ order.condominium.zipCode }}
              </v-flex>
              <v-flex xs2>
                <a target="_blank" :href="'https://www.google.com.br/maps/place/' + order.condominium.address" class="get-map">
                  Como chegar
                </a>
              </v-flex>
            </v-layout>
            <v-layout row wrap  class="mb-4">
              <v-flex xs12 class="titulo-detalhes mt-3">
                Solicitante
              </v-flex>
              <v-flex xs12>
                {{ order.client }}
              </v-flex>
              <v-flex xs12>
                Unidade: {{ order.unit }}
              </v-flex>
              <v-flex xs12>
                E-mail: {{ order.email }}
              </v-flex>
              <v-flex xs12>
                Telefone: {{ order.phone }}
              </v-flex>
               <v-flex xs12>
                Data de realização: {{ order.dateChoosen | dataPrevista }}
              </v-flex>

               <v-flex xs12>
                Hora de realização: {{ order.timeChoosen | horaPrevista }}
              </v-flex>

              <v-flex xs12>
                <strong>
                  Observações:
                </strong>
                {{ order.comments }}
              </v-flex>
               <v-flex xs12>
                <strong>
                  Plataforma de origem do pedido:
                </strong>
                {{ order.origin }}
              </v-flex>
            </v-layout>
            <v-layout row class="mt-3" v-if="false">
              <v-flex>
                <hr>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pt-3 mb-3 text-xs-center" v-if="showOrderBtns">
              <v-flex>
                <v-btn flat color="red" :disabled="loadingOrderActions" @click="cancelOrder" class="ma-0">Recusar pedido</v-btn>
              </v-flex>
              <v-flex>
                <v-btn flat color="blue" :disabled="loadingOrderActions" @click="printOrder(order.id)" class="ma-0">Imprimir pedido</v-btn>
              </v-flex>
              <v-flex>
                <v-btn flat color="green" :disabled="loadingOrderActions" class="ma-0" @click="acceptOrder">Aceitar pedido</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-progress-linear class="loading-modal" v-if="loadingOrderActions" color="error" v-bind:indeterminate="true"></v-progress-linear>
    </v-card>
  </v-dialog>
</template>


<script>
import moment from 'moment'
import 'moment/locale/pt-br'
export default {
  name: 'order-datails',
  data () {
    return {
    }
  },
  methods: {
    acceptOrder () {
      this.$store.dispatch('acceptOrder')
    },
    cancelOrder () {
      this.$store.dispatch('cancelOrder')
    },
    printOrder (id) {
      this.$store.dispatch('printOrder', id)
    }
  },
  computed: {
    order () {
      return this.$store.getters.selectedOrder
    },
    totalPrice () {
      return this.order.itens.reduce((prevVal, elem) => prevVal + (elem.count * elem.price), 0)
    },
    loadingOrderActions () {
      return this.$store.getters.loadingOrderActions
    },
    showOrderBtns () {
      return (this.order.status === 'L' || this.order.status === 'A')
    },
    orderDetailsModal: {
      get () {
        return this.$store.getters.orderDetailsModal
      },
      set (value) {
        this.$store.commit('toggleOrderDetailsModal', value)
      }
    }
  },
  filters: {
    orderDateFilter (value) {
      return moment(value).format('LLL')
    },
    currency (value) {
      if (typeof value !== 'number') return ''
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    dataPrevista (value) {
      moment.locale('pt-BR')
      if (value === null || value === ' ') return ''
      return moment(value).format('L')
    },
    horaPrevista (value) {
      // moment.locale('pt-BR')
      // debugger
      if (value === null || value === ' ') return ''
      // return moment(value).format('LT')
      return value
    }
  }
}
</script>
<style>
.item-box{
  border: 1px solid #bdbdbd;
  border-radius: 15px;
  float: left;
}
.item-imagem{
  width: 60px;
  float: left;
}
.item-detalhes{
  float: left;
  width: calc(100% - 60px);
  width: -moz-calc(100% - 60px);
}
.item-imagem img{
  height: 50px;
  width: 50px;
  border-radius: 100%;
  margin-right: 10px;
}
.item-detalhes .item-titulo{
  font-size: 20px;
  margin-bottom: 0px;
}

.item-preco, .item-rodape, .item-cabecalho{
  float: left;
  width: 100%;
}
/*.price-box{
  border: 1px solid #d9d9d9;
  border-radius: 15px;
  padding: 20px;
  float: left;
  width: 100%;
  position: relative;
}*/
/*.price-box input{
  position: absolute;
  outline: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  padding-left: 37px;
  font-size: 22px;
  color: #5a5a5a;
}*/
/* ajustes */
.condominium-wrapper{
  background-color: #f3f3f3;
  font-size: 16px;
}
.condominium-box{
  border: 2px solid #e4e4e4;
  background-color: #fff;
}
.titulo-detalhes{
    color: #e62039;
    font-size: 21px;
}
.titulo-detalhes .headline{
  font-size: 25px;
}
.titulo-detalhes-categoria{
  font-size: 21px;
  padding-top: 17px;
  color: #707983
}
p{
color: #838789
}
.search-text{
  color:#b1b1b1;
  font-size: 18px;
}
.search-text span{
  color: #e24054;
  font-weight: bold;
}
.no-details .input-group__details{
  display: none!important
}
.no-details .input-group{
  padding: 3px;
  padding-left: 10px;
  border: 1px solid #b1b1b1;
  border-radius: 4px;
}
.titulo-detalhes{
    color: #e62039;
    font-size: 21px;
}
.get-map{
  border: 1px solid #e8e8e8;
  color: #1b74ce!important;
  text-align: center;
  width: 114px;
  padding: 8px;
  float: right;
  box-shadow: 1px 1px 5px #a09e9e9c;
  cursor: pointer;
  text-decoration: none;
}
.divider-red{
  border-color: rgba(245, 49, 74, 0.65);
}
.divider-item{
  border-bottom: 1px solid #cccccc;
}
.payment-method{
  background: #e4e4e4;
  padding: 10px;
  color: #a2a2a2;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// index.vue?39523424